// Common API utility for all API calls
const BASE_URL = process.env.REACT_APP_ADMIN_API_URL;

export async function apiRequest(path, { method = 'GET', body, headers = {}, ...rest } = {}) {
    const token = localStorage.getItem('jwt');
    const fullUrl = path.startsWith('http') ? path : `${BASE_URL}${path}`;
    const fetchHeaders = {
        'Content-Type': 'application/json',
        ...headers,
    };
    if (token) {
        fetchHeaders['Authorization'] = `Bearer ${token}`;
    }
    const response = await fetch(fullUrl, {
        method,
        headers: fetchHeaders,
        ...(body ? { body: JSON.stringify(body) } : {}),
        ...rest,
    });
    if (!response.ok) {
        let errorMsg = 'API request failed';
        try {
            const errData = await response.json();
            errorMsg = errData.error || errorMsg;
        } catch { }
        throw new Error(errorMsg);
    }
    // Try to parse JSON, fallback to text
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
        return response.json();
    }
    return response.text();
} 